/**
 * ЮБуст — VPN for YouTube (uBoost)
 *
 * A VPN aimed at bypassing YouTube blocking in Russia. Detectable, but only from
 * YouTube itself.
 *
 * Its manifest declares two `<all_urls>` grants that would make it detectable from any
 * page — `fonts/Press_Start_2P/*.ttf` and `fonts/CyGrotesk/*.otf` — but neither
 * directory is shipped. The package contains only `fonts/OpenRunde-*.woff2`, which is
 * not exposed. So those grants reach nothing, and the reachable resources are the
 * YouTube-scoped ones. This is the fourth stale manifest found in the top 100, after
 * WPS PDF, ColorZilla and Return YouTube Dislike.
 *
 * Worth noting what detection means here: this identifies a user running a
 * censorship-circumvention tool, to the platform they are using it to reach. That is a
 * more consequential disclosure than most entries in this corpus.
 *
 * Manifest verified against version 8.11.12.
 */

import { probeFetch, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jddgbeighonaipjikdnfdpiefhoomlae';

export const uboostVpn: ExtensionDefinition = {
  id: ID,
  name: 'ЮБуст - VPN для YouTube',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2_000_000,
  requiredOrigin: 'https://www.youtube.com',
  notes:
    'Scoped to YouTube, so only YouTube can enumerate it — and what it reveals is that ' +
    'the visitor is circumventing a block. Its two <all_urls> font grants point at ' +
    'directories the package does not ship, so they expose nothing.',
  signals: [
    {
      id: 'war-player-quality-script',
      kind: 'web-accessible-resource',
      description:
        'Fetch scripts/updateYtbPlayerCurrentQuality.js — the injected player script, ' +
        'exposed only to youtube.com and youtu.be.',
      weight: 1,
      run: () => probeFetch(ID, 'scripts/updateYtbPlayerCurrentQuality.js'),
    },
    {
      id: 'war-icon',
      kind: 'web-accessible-resource',
      description: 'Load assets/icon128.png via <img> to corroborate.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/icon128.png'),
    },
  ],
};
